exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-radio.custom-radio-lg label[data-v-566a887e]{height:30px;padding-right:12px}", ""]);

// exports
